<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'svelte-i18n';
	import { zwaveCall } from 'src/services/xz_http_reqs';
	//Stores
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Types
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id),
		setting = 16,
		inverted = settings?.['Configuration:0']?.[setting] === 1,
		loading = false,
		cache = inverted;

	const sentRequest = async () => {
		inverted = !inverted;
		loading = true;

		const res = await zwaveCall(device, {
			cc: 'Configuration',
			m: 'set',
			ep: 0,
			params: [{ parameter: setting, value: inverted ? 1 : 0 }],
		});

		if (res.isok) {
			const res_get = await zwaveCall(device, {
				cc: 'Configuration',
				m: 'get',
				ep: 0,
				params: [+setting],
			});
		}
		await onSettingsResponse(res, device);
		cache = inverted;
		loading = false;
	};
</script>

<Toggle checked={inverted} size="m" on:click={sentRequest} id="toggle-cef17ff">
	{capFirstChar(
		$format('option_reverse_relays', {
			default: 'If you enable this option, channel 1 and 2 will be swapped.',
		}),
	)}
</Toggle>
